import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import 'reviews2/feed/review-yeti/reply/editor/custom-elements/PartnerCredentials.scss';

export const PartnerCredentials: FunctionComponent = () => {
    const { t } = useTranslation('reviews2');

    return (
        <div className="r4e-review-partner-credentials">
            <span>{t('PARTNER_CREDENTIALS_WARNING')}</span>
        </div>
    );
};
